// extracted by mini-css-extract-plugin
export default {"current":"styles_current__-cGcq","other":"styles_other__CYw6m","navBar":"styles_navBar__XbX3W","divider":"styles_divider__3QQZe"};